import React, { FC } from 'react';
import classNames from 'classnames';
import getClassNames from 'src/common/utils/getClassNames';
import styles from './Modal.module.scss';

const sizes = [
  's',
  'm',
  'l',
] as const;
type Size = typeof sizes[number];

type BodyProps = {
  /**
   * Custom, module for main content of modal.
   */
  slot1: React.ReactNode;
  /**
   * Optional, secondary content module, sits below slot1.
   */
  slot2?: React.ReactNode;
  overflow?: 'auto' | 'visible';
  spacingBottom?: Size;
};

const Body: FC<BodyProps> = ({
  slot1,
  slot2,
  overflow = 'auto',
  spacingBottom = 'l',
}) => (
  <div className={getClassNames(
    styles,
    'body',
    classNames(overflow, spacingBottom && `spacing-${spacingBottom}`),
  )}
  >
    <div className={styles.slotBody}>{slot1}</div>
    {slot2 && <div className={styles.slotBody}>{slot2}</div>}
  </div>
);

export default Body;
